<template>
  <div>
    <p class="font-weight-bolder mb-0">
      Desafio {{ cycle.expected_modules_qty * 6 }} questões
    </p>
    <p class="mb-0">
      {{ cycle.challenge_minutes }} minutos
    </p>
    <CardApplicationDates
      :begin="cycle.begin_challenge_apply"
      :end="cycle.end_challenge_apply"
    />
  </div>
</template>
<script>

import CardApplicationDates from '@/student/components/CardApplicationDates'

export default {
  components: { CardApplicationDates },
  props: {
    cycle: {
      type: Object,
      required: true,
    }
  },
}
</script>
